var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmToArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3088_4215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4493,
    cy: 10.8966,
    r: 10.4493,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.53564 -4.60547H20.3291V16.2931H-7.53564V-4.60547Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.27024 -4.60547L6.35321 3.27504L16.9331 -4.60547H20.3291V-1.90607L9.87985 5.88736L20.3291 13.6373V16.2931H16.846L6.39675 8.49969L-4.00901 16.2931H-7.53564V13.6808L2.87011 5.9309L-7.53564 -1.81899V-4.60547H-4.27024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9248 7.62891L20.3291 14.5516V16.2931L8.53015 7.62891H10.9248ZM2.91365 8.49969L3.17488 10.0235L-5.18455 16.2931H-7.53564L2.91365 8.49969ZM20.3291 -4.60547V-4.47485L9.488 3.71043L9.57508 1.79472L18.1522 -4.60547H20.3291ZM-7.53564 -4.60547L2.87011 3.05735H0.257788L-7.53564 -2.77684V-4.60547Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95719 -4.60547V16.2931H9.92339V-4.60547H2.95719ZM-7.53564 2.36073V9.32692H20.3291V2.36073H-7.53564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.53564 3.79751V7.97722H20.3291V3.79751H-7.53564ZM4.35043 -4.60547V16.2931H8.53015V-4.60547H4.35043Z",
    fill: "#C8102E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.447266H14.4737V10.5525H1",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.61133H14.4737H1ZM1 3.16291H14.4737H1ZM1 4.7208H14.4737H1ZM1 6.2787H14.4737H1ZM1 7.83659H14.4737H1ZM1 9.39449H14.4737H1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.61133H14.4737M1 3.16291H14.4737M1 4.7208H14.4737M1 6.2787H14.4737M1 7.83659H14.4737M1 9.39449H14.4737",
    stroke: "white",
    strokeWidth: 1.62584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0.447266H8.68V5.88937H1",
    fill: "#192F5D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22363 0.44043H14.9412V3.80257H1.22363V0.44043Z",
    fill: "#D90012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22363 3.80273H14.9412V7.16488H1.22363V3.80273Z",
    fill: "#0033A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22363 7.16455H14.9412V10.5267H1.22363V7.16455Z",
    fill: "#F2A800"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.447266,
    width: 10.1053,
    height: 10.1053,
    rx: 5.05263,
    stroke: "#ECF5FE",
    strokeWidth: 0.842105
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3088_4215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.3438,
    cy: 10.8966,
    r: 10.4493,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.64111 -4.60547H26.2237V16.2931H-1.64111V-4.60547Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62429 -4.60547L12.2477 3.27504L22.8277 -4.60547H26.2237V-1.90607L15.7744 5.88736L26.2237 13.6373V16.2931H22.7406L12.2913 8.49969L1.88552 16.2931H-1.64111V13.6808L8.76464 5.9309L-1.64111 -1.81899V-4.60547H1.62429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8193 7.62891L26.2237 14.5516V16.2931L14.4247 7.62891H16.8193ZM8.80818 8.49969L9.06941 10.0235L0.709978 16.2931H-1.64111L8.80818 8.49969ZM26.2237 -4.60547V-4.47485L15.3825 3.71043L15.4696 1.79472L24.0467 -4.60547H26.2237ZM-1.64111 -4.60547L8.76464 3.05735H6.15232L-1.64111 -2.77684V-4.60547Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85172 -4.60547V16.2931H15.8179V-4.60547H8.85172ZM-1.64111 2.36073V9.32692H26.2237V2.36073H-1.64111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.64111 3.79751V7.97722H26.2237V3.79751H-1.64111ZM10.245 -4.60547V16.2931H14.4247V-4.60547H10.245Z",
    fill: "#C8102E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05273 0.447266H19.5264V10.5525H6.05273",
    fill: "#BD3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05273 1.61133H19.5264H6.05273ZM6.05273 3.16291H19.5264H6.05273ZM6.05273 4.7208H19.5264H6.05273ZM6.05273 6.2787H19.5264H6.05273ZM6.05273 7.83659H19.5264H6.05273ZM6.05273 9.39449H19.5264H6.05273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05273 1.61133H19.5264M6.05273 3.16291H19.5264M6.05273 4.7208H19.5264M6.05273 6.2787H19.5264M6.05273 7.83659H19.5264M6.05273 9.39449H19.5264",
    stroke: "white",
    strokeWidth: 1.62584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05273 0.447266H13.7327V5.88937H6.05273",
    fill: "#192F5D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_3088_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27637 0.44043H19.9939V3.80257H6.27637V0.44043Z",
    fill: "#D90012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27637 3.80273H19.9939V7.16488H6.27637V3.80273Z",
    fill: "#0033A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27637 7.16455H19.9939V10.5267H6.27637V7.16455Z",
    fill: "#F2A800"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89453,
    y: 0.447266,
    width: 10.1053,
    height: 10.1053,
    rx: 5.05263,
    stroke: "#ECF5FE",
    strokeWidth: 0.842105
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.447266,
    width: 10.1053,
    height: 10.1053,
    rx: 5.05263,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8648,
    height: 20.8986,
    fill: "white",
    transform: "translate(-7.53564 -4.60547)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4737,
    height: 10.1053,
    fill: "white",
    transform: "translate(1 0.447266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7175,
    height: 10.0864,
    fill: "white",
    transform: "translate(1.22363 0.44043)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.89453,
    y: 0.447266,
    width: 10.1053,
    height: 10.1053,
    rx: 5.05263,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8648,
    height: 20.8986,
    fill: "white",
    transform: "translate(-1.64111 -4.60547)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4737,
    height: 10.1053,
    fill: "white",
    transform: "translate(6.05273 0.447266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_3088_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7175,
    height: 10.0864,
    fill: "white",
    transform: "translate(6.27637 0.44043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmToArm);
export default __webpack_public_path__ + "static/media/ArmToArm.94ec339e1496fee6bc24b60318db94c6.svg";
export { ForwardRef as ReactComponent };